var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import serverUri from "./config";
var WebSocketError = function (error) { return ({
    type: "WebSocketError",
    error: error
}); };
export var WebSocketMessage = function (channel, event, data, token) { return ({
    type: "WebSocketMessage",
    channel: channel,
    event: event,
    data: data,
    token: token
}); };
var createWebSocket = function (dispatch, openAction) {
    var ws = new WebSocket(serverUri.replace("http", "ws"));
    ws.onerror = (function (event) {
        return dispatch(WebSocketError(event.toString()));
    });
    ws.onmessage = (function (event) {
        var data = JSON.parse(event.data);
        if (data.type === "WebSocketError") {
            dispatch(WebSocketError(data.error));
        }
        else {
            dispatch(WebSocketMessage(data.channel, data.event, data.data));
        }
    });
    if (openAction) {
        ws.onopen = openAction;
    }
    // tslint:disable-next-line: no-console
    ws.onclose = function () { return console.warn("Websocket was closed"); };
    return ws;
};
var CONNECTING = 0; // Socket has been created. The connection is not yet open.
var OPEN = 1; // The connection is open and ready to communicate.
var CLOSING = 2; // The connection is in the process of closing.
var CLOSED = 3; // The connection is closed or couldn't be opened.
var WebSocketConnection = /** @class */ (function () {
    function WebSocketConnection(dispatch) {
        var _this = this;
        this.dispatch = dispatch;
        this.pendingMsgs = [];
        this.updateToken = function (token) { return _this.token = token; };
        this.send = function (msg) {
            try {
                if (!_this.connection || [CLOSED, CLOSING].includes(_this.connection.readyState)) {
                    throw new Error("Socket is already closed");
                }
                if (_this.token) {
                    msg.token = _this.token;
                }
                _this.connection.send(JSON.stringify(msg));
            }
            catch (_a) {
                _this.pendingMsgs.push(msg);
                // tslint:disable-next-line: no-console
                console.warn("Unable to open connection to server, retrying in 500ms...");
                setTimeout(function () { return _this.openConnection(); }, 500);
            }
        };
        this.openConnection = function () {
            try {
                _this.connection = createWebSocket(function (msg) {
                    switch (msg.type) {
                        case "WebSocketError":
                            var error = msg.error;
                            _this.dispatch({ action: "error", error: error });
                            break;
                        case "WebSocketMessage":
                            var event = msg.event, channel = msg.channel, data = msg.data;
                            switch (event) {
                                case "update": {
                                    _this.dispatch({ action: "update", payload: { channel: channel, data: data } });
                                    break;
                                }
                                case "delete": {
                                    _this.dispatch({ action: "delete", payload: { channel: channel, id: data.id } });
                                    break;
                                }
                                case "store": {
                                    _this.dispatch({ action: "store", payload: { channel: channel, data: data } });
                                    break;
                                }
                            }
                            break;
                        default:
                            // tslint:disable-next-line: no-console
                            console.error("Unknown message ", msg);
                            break;
                    }
                }, function () {
                    var msgs = __spreadArrays(_this.pendingMsgs);
                    _this.pendingMsgs = [];
                    msgs.forEach(_this.send);
                    _this.dispatch({ action: "foo" });
                });
                return _this.connection;
            }
            catch (_a) {
                // tslint:disable-next-line: no-console
                console.warn("Unable to open connection to server, retrying in 500ms...");
                setTimeout(function () { return _this.openConnection(); }, 500);
                return null;
            }
        };
        this.connection = this.openConnection();
    }
    Object.defineProperty(WebSocketConnection.prototype, "isConnecting", {
        get: function () {
            var _a;
            return ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.readyState) === CONNECTING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebSocketConnection.prototype, "isOpen", {
        get: function () {
            var _a;
            return ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.readyState) === OPEN;
        },
        enumerable: false,
        configurable: true
    });
    return WebSocketConnection;
}());
export { WebSocketConnection };



//////////////////
// WEBPACK FOOTER
// ./src/serverConnection.ts
// module id = 24
// module chunks = 0